import React, { CSSProperties } from 'react'
import Collapse from 'New/groups/components/collapse'

export interface ICategoryItem {
  id: string | number;
  label: string;
}

interface IProps {
  categories?: ICategoryItem[],
  activeId: string | number;
  onSelectItem(item: ICategoryItem): void;
  style?: CSSProperties;
  useHover?: boolean;
}

// 节目分类标签
const CategoryTags: React.FC<IProps> = ({
  categories,
  activeId,
  onSelectItem,
  style,
  useHover = true
}) => {
  return (
    <React.Fragment>
      <Collapse
        lineHeight={28}
        style={style}
        innerStyle={{marginLeft: -8, marginTop: -16}}
      >
        {categories?.map((category, index) => {
          return (
            <button
              type='button'
              className={`category-item ${activeId === category.id ? 'active' : ''}`}
              onMouseEnter={() => useHover && onSelectItem(category)}
              onClick={() => !useHover && onSelectItem(category)}
              key={index}
            >
              {category.label}
            </button>
          )
        })}
      </Collapse>

      <style jsx>
        {`
          .category-item {
            flex: none;
            margin: 16px 0 0px 8px;
            padding: 0 12px;
            height: 28px;
            line-height: 28px;
            border-radius: 100px;
            background-color: #e6e8f2;
            font-size: 14px;
            color: #1f2129;
            outline: none;
          }
          .category-item:hover {
            color: #e62021;
            cursor: pointer;
          }
          .category-item.active {
            background-color: #ffcc32;
            color: #1f2129;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default CategoryTags
